import { Box, Typography } from '@mui/material';

/**
 * @param {Object}   props
 * @param {boolean}  props.isExpanded         
 * @param {Array}    props.columns            
 * @param {Object}   props.item                
 * @param {Array}    props.identificationTypes 
 * @param {Function} props.formatNumber       
 */

const resolveValue = (col, item, identificationTypes, formatNumber) => {
    if (col.type === 'money') return formatNumber(item[ col.id ]);
    if (col.id === 'type_identification') {
        return (
            identificationTypes.find((t) => t.value === item[ col.id ])?.label ??
            'Desconocido'
        );
    }
    return item[ col.id ] || '-';
};

const ExpandedFields = ({ columns, item, identificationTypes, formatNumber }) =>
    columns
        .filter((col) => col.visible)
        .map((col, idx) => (
            <Box key={ idx } className="expanded-field">
                <Typography variant="caption" className="field-label">
                    { col.label }:
                </Typography>
                <Typography variant="body2" className="field-value">
                    { resolveValue(col, item, identificationTypes, formatNumber) }
                </Typography>
            </Box>
        ));

const CollapsedFields = ({ columns, item, identificationTypes, formatNumber }) =>
    columns
        .filter((col) => col.visible && (col.filterable || col.showMobile))
        .map((col, idx) => (
            <Box
                key={idx}
                sx={ { display: 'flex', alignItems: 'center', width: '100%', minWidth: 0, gap: 1 } }
            >
                <Typography variant="caption" className="field-label">
                    { col.label }:
                </Typography>
                <Typography
                    variant="body2"
                    sx={ { minWidth: 0, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }
                >
                    { resolveValue(col, item, identificationTypes, formatNumber) }
                </Typography>
            </Box>
        ));

const ItemFieldDisplay = ({ isExpanded, columns, item, identificationTypes, formatNumber }) => {
    const sharedProps = { columns, item, identificationTypes, formatNumber };

    return (
        <Box sx={ { minWidth: 0 } }>
            {isExpanded
                ? <ExpandedFields  { ...sharedProps } />
                : <CollapsedFields { ...sharedProps } /> }
        </Box>
    );
};

export default ItemFieldDisplay;